import { isNil } from 'lodash'

import { AuthenticationToken } from 'features/user/api/types/authenticationToken'
import { handleErrors200, MutationInputError, ServerError } from './errors'

export type GraphQlResponse<TData = ResponseDataShape> = TData extends ResponseDataShape
  ? {
      data: TData
      errors?: null | ServerError[]
    }
  : Record<string, unknown> & {
      data?: null | Partial<AuthenticationToken>
      errors?: null | ServerError[]
    }

export type ResponseDataShape = {
  [name: string]:
    | null
    | string
    | unknown[]
    | {
        [element: string]: null | undefined | unknown | unknown[]
        errors?: MutationInputError[] | null | unknown
      }
}

export const handleResponse200 = <ResponseData extends ResponseDataShape>({
  response,
}: {
  response: GraphQlResponse<ResponseData> | void
}): ResponseData | undefined => {
  const hasError = (errors: GraphQlResponse<ResponseData>['errors']): errors is ServerError[] =>
    !isNil(errors) && errors.length > 0

  const hasResponseData = (data: GraphQlResponse<ResponseData>['data']): data is ResponseData =>
    data !== undefined && data !== null

  if (response === undefined) {
    return undefined
  } else if (hasError(response.errors)) {
    handleErrors200(response.errors)
  } else if (hasResponseData(response.data)) {
    return response.data
  }
}
